<div class="sidebar" [class.clickopen]="sideBartoggle" [class.hoveropen]="hover" (mouseenter)="hovering()"
  (mouseleave)="hovering()" id="sidenav">
  <div class="logo-details">
  </div>
  <div class="sidenav-content">
    <ul class="nav-list p-0">
      <span class="admin">Admin Tools</span>

   


      <li [routerLink]="['/page-manager/pages']" routerLinkActive="active">
        <mat-icon class="ico me-2">home</mat-icon>
        <span>
          Pages Manager
        </span>
      </li>
   
      <div class="accordion-item">
        <div class="accordion-header" id="headingfour">
          <li class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour"
            aria-expanded="false" aria-controls="collapsefour" [class.active]="activeButton[0]"
            (click)="activatedButton(0)">
            <mat-icon class="ico me-2">description</mat-icon>
            <span>
              Inquiries Lists
              <mat-icon class="down" [class.downClicked]="activeButton[0]">expand_more</mat-icon>
            </span>
          </li>
        </div>
        <div id="collapsefour" class="accordion-collapse collapse" aria-labelledby="headingfour"
          data-bs-parent="#accordionExamples">
          <div class="accordion-body py-2">
            <div class="sub-nav-list">
              <li routerLinkActive="active" routerLink="/content-manager/inquiries">
               
                <span>
                 Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/cali_inquiries">
                <span>
                  Cali Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/baymount_inquiries">
                <span>
                 Baymount Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/offers_inquiries">
                <span>
                  Offers Inquiries
                </span>
              </li>
            </div>
          </div>
        </div>
      </div>
      <!-- <li routerLinkActive="active" routerLink="/content-manager/email_notifications">
        <mat-icon class="ico me-2">description</mat-icon>
        <span>
          Email Notification List
        </span>
      </li> -->
      <div class="accordion-item">
        <div class="accordion-header" id="headingfour">
          <li class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive"
            aria-expanded="false" aria-controls="collapsefive" [class.active]="activeButton[1]"
            (click)="activatedButton(1)">
            <mat-icon class="me-2">notifications</mat-icon>
            <span>
              Email Notification List
              <mat-icon class="down" [class.downClicked]="activeButton[1]">expand_more</mat-icon>
            </span>
          </li>
        </div>
        <div id="collapsefive" class="accordion-collapse collapse" aria-labelledby="headingfour"
          data-bs-parent="#accordionExamples">
          <div class="accordion-body py-2">
            <div class="sub-nav-list">
              <li routerLinkActive="active"  routerLink="/content-manager/email_notifications_inquiries">
                <span>
                 Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/cali_notifications_inquiries">
                <span>
                  Cali Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/baymount_notifications_inquiries">
                <span>
                  Baymount Inquiries
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/email_notifications_offers">
                <span>
                 Offers
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/email_notifications_axa_offers">
                <span>
                 Axa Offers
                </span>
              </li>
              
            
            </div>
          </div>
        </div>
      </div>



      <li routerLinkActive="active" routerLink="/content-manager/faqs">
        <mat-icon class="ico me-2">contact_support</mat-icon>
        <span>
          Frequently Asked Questions
        </span>
      </li>

      <li routerLinkActive="active" routerLink="/content-manager/media_categories">
        <mat-icon class="ico me-2">calendar_view_day</mat-icon>
        <span>
          Media Center
        </span>
      </li>
      <li routerLinkActive="active" routerLink="/content-manager/cali_units">
        <mat-icon class="ico me-2">aspect_ratio</mat-icon>
        <span>
         Cali Units
        </span>
      </li>
      <li routerLinkActive="active" routerLink="/content-manager/baymount_units">
        <mat-icon class="ico me-2">aspect_ratio</mat-icon>
        <span>
         Baymount Units
        </span>
      </li>
      <li routerLink="/content-manager/offers" routerLinkActive="active">
        <mat-icon class="me-2">assessment</mat-icon>
        <span>
          Offers
        </span>
      </li>
      <!-- <div class="accordion-item">
        <div class="accordion-header" id="headingThree">
          <li class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
            aria-expanded="false" aria-controls="collapseThree" [class.active]="activeButton[1]"
            (click)="activatedButton(1)">
            <mat-icon class="me-2">assignment</mat-icon>
            <span>
              Vacancies
              <mat-icon class="down" [class.downClicked]="activeButton[1]">expand_more</mat-icon>
            </span>
          </li>
        </div>
        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
          data-bs-parent="#accordionExample">
          <div class="accordion-body py-2">
            <div class="sub-nav-list">
              <li routerLinkActive="active"  routerLink="/content-manager/vacancies">
                <span>
                 Our  Vacancies
                </span>
              </li>
              <li routerLinkActive="active" routerLink="/content-manager/applicants">
                <span>
                  Applicants
                </span>
              </li>

            </div>
          </div>
        </div>
      </div> -->
      <li routerLinkActive="active" [routerLink]="['/settings']">
        <mat-icon class="me-2">settings</mat-icon>
        <span>
          Site Settings
        </span>
      </li>

      <span class="other">Other</span>
      <li routerLinkActive="active" [routerLink]="['/users/edit/admins/profile/'+User.id]">
        <mat-icon class="me-2">account_box</mat-icon>
        <span>
          My Account
        </span>
      </li>
      <li class="differ" data-bs-toggle="modal" data-bs-target="#exampleModal">
        <mat-icon class="log me-2">logout</mat-icon>
        <span class="red">
          Log Out
        </span>
      </li>

    </ul>
  </div>
</div>
<div class="container-layout">
  <div class="header">
    <app-header (toggleSidebarForMe)="toggling()"></app-header>
  </div>
  <main class="main-content container-page py-4">
    <router-outlet></router-outlet>
  </main>
  <footer class=" copyright text-end ">
    <div class=" container-page">
      © Copyrights MAVEN Developments {{currentYear}} All rights reserved. Made with Nuts by <a class="ms-1" href="https://socialnuts-eg.com/"
        target="_blank">Social
        Nuts</a>
    </div>

  </footer>

</div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-center">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h4 class="text-center mb-3 fw-bold">Log Out </h4>
        <p> Are you Sure you want to Log Out ??</p>
      </div>
      <div class="modal-footer text-center d-flex justify-content-center">
        <button type="button" class="btn colord" id="" (click)="logOut()" data-bs-dismiss="modal">Log Out</button>
        <button type="button" class="btn cancel" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
